/**
 * ScrambleSection - View component for displaying the scramble
 * Pure presentation component with no business logic
 * Supports edit mode and lock functionality
 */

import React from 'react';

export default function ScrambleSection({ 
  scramble, 
  isEditing, 
  editValue, 
  isLocked,
  onEdit,
  onSave,
  onCancel,
  onEditChange,
  onToggleLock
}) {
  return (
    <div>
      <div style={styles.headerContainer}>
        <h2>Scramble</h2>
        <div style={styles.buttonContainer}>
          <button 
            onClick={onToggleLock}
            style={{
              ...styles.lockButton,
              ...(isLocked ? styles.lockButtonLocked : {})
            }}
            title={isLocked ? "Unlock scramble" : "Lock scramble"}
          >
            {isLocked ? '🔒 Locked' : '🔓 Unlocked'}
          </button>
          {!isEditing && !isLocked && (
            <button onClick={onEdit} style={styles.editButton}>
              ✏️ Edit
            </button>
          )}
        </div>
      </div>

      {isEditing ? (
        <div style={styles.editContainer}>
          <input
            type="text"
            value={editValue}
            onChange={(e) => onEditChange(e.target.value)}
            style={styles.editInput}
            autoFocus
            placeholder="Enter scramble moves..."
          />
          <div style={styles.editButtonContainer}>
            <button onClick={onSave} style={styles.saveButton}>
              ✓ Save
            </button>
            <button onClick={onCancel} style={styles.cancelButton}>
              ✗ Cancel
            </button>
          </div>
        </div>
      ) : (
        <pre style={{
          ...styles.scrambleDisplay,
          ...(isLocked ? styles.scrambleDisplayLocked : {})
        }}>
          {scramble || 'No scramble set'}
        </pre>
      )}
    </div>
  );
}

const styles = {
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px'
  },
  buttonContainer: {
    display: 'flex',
    gap: '8px'
  },
  lockButton: {
    padding: '6px 12px',
    fontSize: '0.9em',
    border: '1px solid #ccc',
    borderRadius: '4px',
    background: '#fff',
    color: '#000',
    cursor: 'pointer',
    transition: 'all 0.2s'
  },
  lockButtonLocked: {
    background: '#ffeaa7',
    borderColor: '#fdcb6e',
    color: '#000',
    fontWeight: 'bold'
  },
  editButton: {
    padding: '6px 12px',
    fontSize: '0.9em',
    border: '1px solid #007bff',
    borderRadius: '4px',
    background: '#007bff',
    color: '#fff',
    cursor: 'pointer',
    transition: 'all 0.2s'
  },
  scrambleDisplay: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    width: '100%',
    fontFamily: 'monospace',
    fontSize: '1.1em',
    background: '#f8f8f8',
    padding: '8px',
    borderRadius: '6px',
    boxSizing: 'border-box',
    transition: 'all 0.2s'
  },
  scrambleDisplayLocked: {
    background: '#fffacd',
    border: '2px solid #ffd700',
    fontWeight: 'bold'
  },
  editContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  editInput: {
    width: '100%',
    padding: '8px',
    fontSize: '1.1em',
    fontFamily: 'monospace',
    border: '2px solid #007bff',
    borderRadius: '6px',
    boxSizing: 'border-box'
  },
  editButtonContainer: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end'
  },
  saveButton: {
    padding: '8px 16px',
    fontSize: '0.95em',
    border: 'none',
    borderRadius: '4px',
    background: '#28a745',
    color: '#fff',
    cursor: 'pointer',
    fontWeight: 'bold'
  },
  cancelButton: {
    padding: '8px 16px',
    fontSize: '0.95em',
    border: 'none',
    borderRadius: '4px',
    background: '#dc3545',
    color: '#fff',
    cursor: 'pointer',
    fontWeight: 'bold'
  }
};
